<template>
  <cv-code-snippet kind="inline" class="max-w-full">
    <slot />
  </cv-code-snippet>
</template>
